// @flow
import React from 'react';

import Popup from '../Popup';
import Content from './Content';

type StudentSchedulePopUpProps = {
  id: string
}

const StudentSchedulePopUp = ({
  id,
}: StudentSchedulePopUpProps) => (
  <Popup
    id={id}
    theme="main"
    transitionType="slideDown"
    transitionMs={600}
  >
    <Content />
  </Popup>
);

export default StudentSchedulePopUp;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulePopUp/index.jsx